import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@src/components/ui/Icon';
import styles from './Toast.module.scss';
const VARIANT_ICON = {
    success: 'fa-solid fa-check-circle',
    error: 'fa-solid fa-times-circle',
    warning: 'fa-solid fa-exclamation-triangle',
};
export const Toast = ({ message, variant = 'success', noBorder, onClose, }) => {
    const classes = [
        styles.toast,
        styles[`toast--${variant}`],
        noBorder ? styles['toast--no-border'] : '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: classes, role: "alert", children: [_jsx("div", { className: styles.toast__icon, children: _jsx(Icon, { faIconName: VARIANT_ICON[variant] }) }), _jsx("div", { className: styles.toast__content, children: _jsx("p", { className: styles.toast__message, children: message }) }), onClose && (_jsx("button", { type: "button", className: styles.toast__close, onClick: onClose, "aria-label": "Close toast", children: _jsx(Icon, { faIconName: "fa-solid fa-times" }) }))] }));
};
